import { render, staticRenderFns } from "./DamageKanban.vue?vue&type=template&id=71dbd0c1"
import script from "./DamageKanban.vue?vue&type=script&lang=ts"
export * from "./DamageKanban.vue?vue&type=script&lang=ts"
import style0 from "./DamageKanban.vue?vue&type=style&index=0&id=71dbd0c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports